import { render, staticRenderFns } from "./changeRoleDialog.vue?vue&type=template&id=0bee11de&scoped=true"
import script from "./changeRoleDialog.vue?vue&type=script&lang=js"
export * from "./changeRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./changeRoleDialog.vue?vue&type=style&index=0&id=0bee11de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee11de",
  null
  
)

export default component.exports